
<div class="scheduled-report-empty">
  <div class="empty-card">
    <div class="empty-left">
      <h5 class="empty-title">No Scheduled Reports Created Yet</h5>
      <p class="empty-desc mt-2">
        Set it once, and let Scheduled Reports deliver your data automatically. Decide what to send, when to send it, and who receives it. No manual work required.
      </p>
      <ul class="empty-features">
        <li>
          <span class="feature-icon">
            <v-icon small color="#1B6EF3">mdi-file-document-outline</v-icon>
          </span>
          Pick any report template
        </li>
        <li>
          <span class="feature-icon">
            <v-icon small color="#1B6EF3">mdi-calendar-clock</v-icon>
          </span>
          Set frequency and delivery date/time
        </li>
        <li>
          <span class="feature-icon">
            <v-icon small color="#1B6EF3">mdi-email-outline</v-icon>
          </span>
          Send automatically to one or multiple recipients
        </li>
        <li>
          <span class="feature-icon">
            <v-icon small color="#1B6EF3">mdi-clock-outline</v-icon>
          </span>
          Run on schedule always on time
        </li>
      </ul>
      <a href="/dashboard/scheduled_report/new">
        <button class="btn btn-primary d-flex align-items-center">
          <v-icon small color="#ffffff" class="mr-1">mdi-plus</v-icon>
          New Scheduled Report
        </button>
      </a>
    </div>
    <div class="empty-right mt-3">
      <div class="how-card">
        <div class="how-title">How it works</div>

        <div class="how-step">
          <div class="step-icon step-icon--blue">
            <v-icon small color="#1B6EF3">mdi-file-document-outline</v-icon>
          </div>
          <div class="step-body">
            <div class="step-label">Choose a template</div>
            <div class="step-value">Monthly Case Overview</div>
          </div>
        </div>

        <div class="how-arrow">
          <v-icon small color="#BDBDBD">mdi-arrow-down</v-icon>
        </div>

        <div class="how-step">
          <div class="step-icon step-icon--orange">
            <v-icon small color="#F2994A">mdi-clock-outline</v-icon>
          </div>
          <div class="step-body">
            <div class="step-label">Set frequency</div>
            <div class="step-value">Every month • 9:00 AM</div>
          </div>
        </div>

        <div class="how-arrow">
          <v-icon small color="#BDBDBD">mdi-arrow-down</v-icon>
        </div>

        <div class="how-step">
          <div class="step-icon step-icon--purple">
            <v-icon small color="#7B61FF">mdi-email-outline</v-icon>
          </div>
          <div class="step-body">
            <div class="step-label">Send to recipients</div>
            <div class="step-value">johndoe@mail.com <span class="more-pill">+2 more</span></div>
          </div>
        </div>

        <div class="how-divider"></div>

        <div class="how-file">
          <div class="file-icon">
            <v-icon small color="#4F4F4F">mdi-file-document-outline</v-icon>
          </div>
          <div class="file-body">
            <div class="file-name">
              <span>monthly</span>-case-overview-jan-2026
            </div>
            <div class="file-meta">Delivered automatically on schedule</div>
          </div>
          <span class="file-badge">CSV</span>
        </div>
      </div>
    </div>
  </div>
</div>
